import { SvgIcon } from '@material-ui/core'

export default function CollaboratorsIcon(props: any) {
    return (
        <SvgIcon viewBox="0 0 25 24" fill="none" {...props}>
            <g>
                <ellipse cx="8.10356" cy="7.96711" rx="4.00004" ry="3.6761" fill="currentColor" />
                <ellipse cx="17.6035" cy="9.34549" rx="3.50003" ry="3.21658" fill="currentColor" />
                <path
                    d="M12.9498 19.9146C14.0267 19.9146 15.1037 18.6778 15.1037 17.4403C15.1037 14.4712 11.3134 13.4814 8.10358 13.4814C4.89373 13.4814 1.10352 14.4712 1.10352 17.4403C1.10352 18.6778 2.18045 19.9146 3.25738 19.9146H12.9498Z"
                    fill="currentColor"
                />
                <path
                    d="M17.6035 14.4004C20.1255 14.4004 23.1035 15.249 23.1035 17.7939C23.1034 18.8546 22.2573 19.915 21.4111 19.915H16.2646C16.7497 19.22 17.0751 18.3581 17.0752 17.4404C17.0752 16.2545 16.6821 15.286 16.0742 14.5088C16.5841 14.4352 17.1027 14.4004 17.6035 14.4004ZM13.5557 15.3389C14.2385 15.8711 14.6318 16.5598 14.6318 17.4404C14.6317 17.9273 14.4168 18.4396 14.0752 18.832C13.7296 19.2289 13.3106 19.4422 12.9502 19.4424H12.8047C12.3945 19.0344 12.1036 18.4148 12.1035 17.7939C12.1035 16.6678 12.6869 15.8741 13.5557 15.3389Z"
                    fill="currentColor"
                />
            </g>
        </SvgIcon>
    )
}
